<template>
    <div style="min-width:200px" class="mr-0 mr-lg-3">
        <CRow>
            <CCol sm="12" md="12" xl="12" xs="12">
                <BaseSelect :options="locationSelectInput.options" :data="locationSelectInput.data"
                    ref="locationSelectInput">
                </BaseSelect>
            </CCol>
            <!-- <CCol sm="2" md="2" xl="2" xs="2"
                style="display:inline-flex; padding-left: 0 !important; padding-right: 0 !important;">
                <CButton v-if="isChange" color="info" variant="outline" style="border: none;"
                    v-c-tooltip.click="{ content: 'Cập nhật địa bàn' }" square size="sm" @click="updateLocation()">
                    <i class="fa fa-check" />
                </CButton>
            </CCol> -->
        </CRow>
    </div>
</template>
<script>

import BaseSelect from "@/views/base/BaseSelect2";

export default {
    name: 'TheHeaderChooseLocation',
    components: {
        BaseSelect
    },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success",
        },
        showErrorMsg: {
            type: "error",
            title: "Error",
        },
        showWarningMsg: {
            type: "warn",
            title: "warn",
        },
    },
    data() {
        let that = this;
        return {
            isChange: false,
            locationCode: '',
            locationSelectInput: {
                options: {
                    filter: true,
                    // label: "Tỉnh/Thành phố",
                    // 'selectAllText': "Tỉnh/Thành phố",
                    'keyField': 'key',
                    'valueField': 'value',
                    lazyLoad: this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_MANAGEMENT') ? false : true
                },
                data: {
                    name: "locationCode",
                    items: [],
                    model: '',
                    source: {
                        url: '/location/get-list-province',
                        response: function (dataResponse) {
                            that.locationSelectInput.data.items = dataResponse.data;
                            setTimeout(() => {
                                that.locationSelectInput.data.model = that.locationCode;
                            }, 1000)

                        }
                    },
                    updateTrigger: function () {
                        return;
                    },
                }
            },
        }
    },
    mounted() {
        this.loadLocationCache();
    },
    computed: {},
    methods: {
        loadLocationCache() {
            let that = this
            this.$helper.loadDataSource({
                url: "/location/get-location-cache",
                successCallback: function (response) {
                    that.locationCode = response.data.data;
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });
        },
        updateLocation: function () {
            let that = this
            this.$helper.loadDataSource({
                url: "/location/cache-location",
                dataSubmit() {
                    return {
                        code: that.locationSelectInput.data.model
                    };
                },
                successCallback: function () {
                    that.showSuccessMsg({ message: "Thay đổi địa bàn thành công" });
                    window.location.reload();
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });

        },
    },
    watch: {
        'locationSelectInput.data.model': function (value) {
            if (value && value != '' && value != this.locationCode) {
                this.updateLocation();
                // this.isChange = true;
                // } else {
                //     this.isChange = false;
            }
        },
    }
}
</script>